import { useNavigate } from "react-router-dom";
import { startBoosterCheckout } from "../../lib/billing";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export default function RunLimitDialog({ open, onClose }) {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={(value) => { if (!value) onClose?.(); }}>
      <DialogContent data-testid="run-limit-dialog" style={{
        background: "var(--color-background-secondary)",
        borderColor: "var(--color-border-primary)", color: "var(--color-text-primary)",
      }}>
        <DialogHeader><DialogTitle>Monthly architecture runs reached</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-text-secondary">
          Your existing projects remain available to view, edit, and export. Get 20 more architecture runs for $10, or upgrade your plan.
        </DialogDescription>
        <div className="flex flex-wrap gap-3 mt-3">
          <button type="button" data-testid="buy-run-booster" onClick={startBoosterCheckout}
            className="rounded-lg px-4 py-2 text-sm font-semibold"
            style={{ background: "var(--color-accent)", color: "#0a0a0a" }}>
            Buy 20 runs · $10
          </button>
          <button type="button" data-testid="upgrade-run-plan" onClick={() => navigate("/pricing")}
            className="rounded-lg border px-4 py-2 text-sm"
            style={{ borderColor: "var(--color-border-primary)" }}>
            View plans
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
